import {
    ApiUtils,
    _axios
} from '@/api/apiUtil.js';

import constant from '@/util/constant.js';
const api = {
    ListProdectName: (params, successCallback, failCallback, exceptionCallback) => {
        ApiUtils.postLoadingAjax(constant.serverUrl + "/global/record/selectProductName", params, successCallback, failCallback, exceptionCallback);
    },ListRecordDate: (params, successCallback, failCallback, exceptionCallback) => {
        ApiUtils.postLoadingAjax(constant.serverUrl + "/global/record/selectRecordDate", params, successCallback, failCallback, exceptionCallback);
    },selectRecordRemark: (params, successCallback, failCallback, exceptionCallback) => {
        ApiUtils.getLoadingAjax(constant.serverUrl + "/global/record/selectRecordRemark", params, successCallback, failCallback, exceptionCallback);
    },toDetail: (params, successCallback, failCallback, exceptionCallback) => {
        ApiUtils.postLoadingAjax(constant.serverUrl + "/global/record/selectDevRemake", params, successCallback, failCallback, exceptionCallback);
    },getNotRecordTeam: (params, successCallback, failCallback, exceptionCallback) => {
        ApiUtils.postLoadingAjax(constant.serverUrl + "/global/record/selectNotRecordTeam", params, successCallback, failCallback, exceptionCallback);
    },selectTeamName: (params, successCallback, failCallback, exceptionCallback) => {
        ApiUtils.postLoadingAjax(constant.serverUrl + "/global/record/selectTeamName", params, successCallback, failCallback, exceptionCallback);
    }
}

export default api;
